var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.651,
    height: 6.39,
    viewBox: "0 0 3.651 6.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11320",
    "data-name": "Path 11320",
    d: "M60.809,237.549H55.217a.381.381,0,0,0-.281.12.4.4,0,0,0,0,.57l2.8,2.84a.388.388,0,0,0,.562,0l2.8-2.84a.4.4,0,0,0,0-.571A.381.381,0,0,0,60.809,237.549Z",
    transform: "translate(-237.549 61.208) rotate(-90)",
    fill: "#1e2439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewAll);
export default __webpack_public_path__ + "static/media/IconViewAll.869fd73b.svg";
export { ForwardRef as ReactComponent };